import { render, staticRenderFns } from "./GeodesiaList.vue?vue&type=template&id=40248436&scoped=true"
import script from "./GeodesiaList.vue?vue&type=script&lang=js"
export * from "./GeodesiaList.vue?vue&type=script&lang=js"
import style0 from "./GeodesiaList.vue?vue&type=style&index=0&id=40248436&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40248436",
  null
  
)

export default component.exports